'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = SpicySvg;

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function SpicySvg(props) {
    var size = props.size,
        primaryColor = props.primaryColor,
        _props$i18n = props.i18n,
        i18n = _props$i18n === undefined ? { get: function get() {
            return null;
        } } : _props$i18n;


    return _react2.default.createElement(
        'svg',
        { role: 'img', 'aria-labelledby': 'outImgSpicy', width: size, height: size, viewBox: '0 0 28 28', xmlns: 'http://www.w3.org/2000/svg', 'data-hook': 'wixrest-menus-icon-outline-spicy' },
        _react2.default.createElement(
            'title',
            { id: 'outImgSpicy' },
            ' ',
            i18n.get('openrest_menubuilderv3_dishlabels_spicy') || 'spicy'
        ),
        _react2.default.createElement(
            'g',
            { fill: primaryColor },
            _react2.default.createElement('path', {
                d: 'M17.6318 11.0708c.254 1.357-.996 3.553-3.11 5.464-1.963 1.777-5.322 2.156-6.422 1.877.183-.049.42-.095.615-.134 1.258-.249 3.364-.664 4.543-3.156.478-1.009.543-2.007.595-2.808.011-.178.022-.348.037-.509.068-.713.273-1.641.864-2.007.51-.317 1.223-.151 1.729.044h.001c.665.254 1.041.656 1.148 1.229m1.158-4.503c-.412-.143-.826-.11-1.202.098-.681.377-1.083 1.249-1.295 1.866-1.033-.246-1.742-.02-2.172.246-.809.502-1.289 1.482-1.425 2.914-.017.172-.028.355-.041.545-.047.735-.101 1.569-.481 2.372-.921 1.946-2.457 2.249-3.691 2.492-.822.161-1.844.363-1.815 1.379.006.239.113.68.748.952.382.163.928.245 1.568.245 1.916 0 4.669-.738 6.342-2.251 2.488-2.249 3.824-4.769 3.485-6.576-.112-.593-.451-1.362-1.396-1.892.176-.514.456-1.077.755-1.242.075-.042.138-.046.224-.016.313.11.655-.056.764-.368.11-.313-.055-.655-.368-.764' }),
            _react2.default.createElement('path', {
                d: 'M13.6499 25.999c-6.81 0-12.35-5.54-12.35-12.349 0-6.81 5.54-12.35 12.35-12.35s12.35 5.54 12.35 12.35c0 6.809-5.54 12.349-12.35 12.349m0-25.999c-7.527 0-13.65 6.123-13.65 13.65 0 7.526 6.123 13.65 13.65 13.65s13.651-6.124 13.651-13.65c0-7.527-6.124-13.65-13.651-13.65' })
        )
    );
}

SpicySvg.displayName = 'SpicySvg';
SpicySvg.propTypes = {
    size: _propTypes2.default.number,
    primaryColor: _propTypes2.default.string
};
SpicySvg.defaultProps = {
    size: 28,
    primaryColor: '#c4270e'
};